import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const CustomTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: theme.shadows[4],
    fontSize: 16,
    border: "1px solid #dadde9"
  }
}))(Tooltip);

export default CustomTooltip;



// WEBPACK FOOTER //
// ./src/utils/CustomTooltip.js